import React from 'react';

/**
 * Disclosure shown wherever licensed historical rating data appears.
 * The underlying reviews were collected on rehabs.com / recovery.org and
 * their text is not republished here — only the numeric aggregates.
 */
const RatingProvenance: React.FC<{ count: number; compact?: boolean }> = ({ count, compact }) => {
  if (compact) {
    return (
      <span style={{ fontSize: '11px', color: '#888' }}>
        Historical rating · {count} licensed reviews{' '}
        <a href="/review-policy" style={{ color: '#888' }}>ⓘ</a>
      </span>
    );
  }
  return (
    <div style={{
      padding: '12px 16px', background: '#f8f9fa', border: '1px solid #e0e0e0',
      borderRadius: '8px', fontSize: '13px', color: '#555', lineHeight: 1.6,
    }}>
      Rating based on {count} reviews collected on rehabs.com and recovery.org through 2023.
      TopRatedRehabs licensed this rating data; we did not collect these reviews and do not
      republish their text. New reviews are collected and verified directly on TopRatedRehabs.{' '}
      <a href="/review-policy" style={{ color: '#1a237e' }}>Review policy →</a>
    </div>
  );
};

export default RatingProvenance;
